// @generated by protoc-gen-es v1.0.0 with parameter "rewrite_imports=./gogoproto/**/*_pb.js:@buf/cosmos_gogo-proto.bufbuild_es"
// @generated from file tendermint/types/params.proto (package tendermint.types, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Duration, proto3 } from "@bufbuild/protobuf";

/**
 * ConsensusParams contains consensus critical parameters that determine the
 * validity of blocks.
 *
 * @generated from message tendermint.types.ConsensusParams
 */
export const ConsensusParams = proto3.makeMessageType(
  "tendermint.types.ConsensusParams",
  () => [
    { no: 1, name: "block", kind: "message", T: BlockParams },
    { no: 2, name: "evidence", kind: "message", T: EvidenceParams },
    { no: 3, name: "validator", kind: "message", T: ValidatorParams },
    { no: 4, name: "version", kind: "message", T: VersionParams },
    { no: 5, name: "abci", kind: "message", T: ABCIParams },
  ],
);

/**
 * BlockParams contains limits on the block size.
 *
 * @generated from message tendermint.types.BlockParams
 */
export const BlockParams = proto3.makeMessageType(
  "tendermint.types.BlockParams",
  () => [
    { no: 1, name: "max_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "max_gas", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * EvidenceParams determine how we handle evidence of malfeasance.
 *
 * @generated from message tendermint.types.EvidenceParams
 */
export const EvidenceParams = proto3.makeMessageType(
  "tendermint.types.EvidenceParams",
  () => [
    { no: 1, name: "max_age_num_blocks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "max_age_duration", kind: "message", T: Duration },
    { no: 3, name: "max_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * ValidatorParams restrict the public key types validators can use.
 * NOTE: uses ABCI pubkey naming, not Amino names.
 *
 * @generated from message tendermint.types.ValidatorParams
 */
export const ValidatorParams = proto3.makeMessageType(
  "tendermint.types.ValidatorParams",
  () => [
    { no: 1, name: "pub_key_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * VersionParams contains the ABCI application version.
 *
 * @generated from message tendermint.types.VersionParams
 */
export const VersionParams = proto3.makeMessageType(
  "tendermint.types.VersionParams",
  () => [
    { no: 1, name: "app", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * HashedParams is a subset of ConsensusParams.
 *
 * It is hashed into the Header.ConsensusHash.
 *
 * @generated from message tendermint.types.HashedParams
 */
export const HashedParams = proto3.makeMessageType(
  "tendermint.types.HashedParams",
  () => [
    { no: 1, name: "block_max_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "block_max_gas", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * ABCIParams configure functionality specific to the Application Blockchain Interface.
 *
 * @generated from message tendermint.types.ABCIParams
 */
export const ABCIParams = proto3.makeMessageType(
  "tendermint.types.ABCIParams",
  () => [
    { no: 1, name: "vote_extensions_enable_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

